module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_3.cecfcbcc.png";